import { Badge, Col, Row } from "antd";

import React, { useEffect, useState } from "react";
import useIsDesktop from "../utils/hooks/useIsDesktop";
import Typography from "../components/Typography";
import { COLORS } from "../constants/Colors";
import SearchCardWithFilter from "../components/SearchCardWithFilter";
// import ShipmentList from "../components/ShipmentList";
import { instance } from "../components/AxiosClient";
import GetProfile from "../components/VariableStore";
import { useDebounce } from "../utils/hooks/useDebounce";
import _ from "lodash";
import { useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import FilterTracking from "../components/FilterTracking";
import moment from "moment";
import {
  errorNotification,
  successNotification,
} from "../components/Notification";
import { useIsMoblie, useIsTablet } from "../utils/hooks/useMobile";

const Tracking = () => {
  const intl = useIntl();
  const isDesktop = useIsDesktop();
  const isMobile = useIsMoblie();
  const state = useSelector((state) => state);
  const [shipmentData, setShipmentData] = useState([]);
  const [shipmentSearch, setShipmentSearch] = useState();
  const [pagination, setPagination] = useState(1);
  const [total, setTotal] = useState();
  const useDebounceSearch = useDebounce(shipmentSearch, 500);
  const parsLocal = JSON.parse(localStorage.getItem("persist:loop_store"));
  const customerData = JSON.parse(parsLocal.customerProfileReducer);
  const [event, setEvent] = useState(false);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterDot, setFilterDot] = useState(false);
  const [shipmentStatus, setShipmentStatus] = useState([]);
  const [shipmentFilter, setShipmentFilter] = useState({
    customerName: "",
    customerPhone: "",
    orderStatus: undefined,
    fromCreateDate: undefined,
    toCreateDate: undefined,
  });

  const comCode = GetProfile("customerCode") || _.get(customerData, "comCode");
  const customerId =
    GetProfile("customerId") || _.get(customerData, "customerId");

  useEffect(() => {
    if (comCode && customerId) {
      getOrdersList();
    }
  }, [
    useDebounceSearch,
    comCode,
    customerId,
    pagination,
    event,
    state.globalReducer.triggerOrder,
  ]);

  const getOrdersList = async () => {
    const search = {
      "contact.customerContactName": _.get(shipmentFilter, "customerName")
        ? _.get(shipmentFilter, "customerName")
        : undefined,
      "contact.customerContactPhone": _.get(shipmentFilter, "customerPhone")
        ? _.get(shipmentFilter, "customerPhone")
        : undefined,
      "customer.comtomerName": undefined,
      "destination.address": "",
      orderNo: shipmentSearch,
      sizesizeName: "",
      sourceaddress: "",
      weightTxt: "",
      fromCreateDate: _.get(shipmentFilter, "fromCreateDate")
        ? moment(new Date(_.get(shipmentFilter, "fromCreateDate"))).format(
            "YYYY-MM-DD"
          )
        : "",
      toCreateDate: _.get(shipmentFilter, "toCreateDate")
        ? moment(new Date(_.get(shipmentFilter, "toCreateDate"))).format(
            "YYYY-MM-DD"
          )
        : "",
      orderStatus: _.get(shipmentFilter, "orderStatus")
        ? _.get(shipmentFilter, "orderStatus")
        : "",
    };

    const body = {
      search: search,
      "customer.customerId": customerId,
      pageNumber: shipmentSearch ? 1 : pagination,
      limit: 10,
    };

    try {
      const response = await instance.post(
        `/v5/order/manager/company/${comCode}/web/deliveryorder/report/loopmerchant`,
        body
      );
      setShipmentData(response.data.data.list);
      setTotal(response.data.data.allRows);
      setShipmentStatus(response.data.data.statusList);
    } catch (error) {
      return error.response.data;
    }
  };

  const handleSerchShipment = (values) => {
    setShipmentSearch(values);
  };

  const handleFilterShipment = (values, key) => {
    // console.log('orderStatus',moment(new Date(values)).format('YYYY-MM-DD'),'/key:',values);
    if (values === "" || values === undefined || values === null) {
      setFilterDot(false);
    } else {
      setFilterDot(true);
    }

    setShipmentFilter((prev) => ({ ...prev, [key]: values }));
  };

  // const handleFilterShipmentDate = (values) => {
  //   console.log('SSorderStatus',moment(values));
  //   if (values === '' || values === undefined || values === null) {
  //     setFilterDot(false)
  //   }else{
  //     setFilterDot(true)
  //   }
  //   setShipmentFilter((prev) => ({ ...prev, [key]: values }));
  // };

  const handleChangePage = (value) => {
    setPagination(value);
  };

  const handleApply = () => {
    setEvent((prev) => !prev);
    setPagination(1);
  };

  const handleReset = () => {
    setShipmentFilter({
      customerName: "",
      customerPhone: "",
      orderStatus: undefined,
      fromCreateDate: undefined,
      toCreateDate: undefined,
    });
    setFilterDot(false);
    setEvent((prev) => !prev);
    setPagination(1);
  };

  const onToggleFilter = () => {
    setFilterVisible((prev) => !prev);
  };

  const exportOrdersList = async () => {
    const search = {
      "contact.customerContactName": _.get(shipmentFilter, "customerName")
        ? _.get(shipmentFilter, "customerName")
        : undefined,
      "contact.customerContactPhone": _.get(shipmentFilter, "customerPhone")
        ? _.get(shipmentFilter, "customerPhone")
        : undefined,
      "customer.comtomerName": undefined,
      "destination.address": "",
      orderNo: shipmentSearch,
      sizesizeName: "",
      sourceaddress: "",
      weightTxt: "",
      fromCreateDate: _.get(shipmentFilter, "fromCreateDate")
        ? moment(new Date(_.get(shipmentFilter, "fromCreateDate"))).format(
            "YYYY-MM-DD"
          )
        : "",
      toCreateDate: _.get(shipmentFilter, "toCreateDate")
        ? moment(new Date(_.get(shipmentFilter, "toCreateDate"))).format(
            "YYYY-MM-DD"
          )
        : "",
      orderStatus: _.get(shipmentFilter, "orderStatus")
        ? _.get(shipmentFilter, "orderStatus")
        : "",
    };

    const body = {
      search: search,
      "customer.customerId": customerId,
      limit: total,
      viewFormat: [
        {
          colName: intl.formatMessage({
            id: "deliveryShipmentColumnsON",
            defaultMessage: "Order No.",
          }),
          sequence: 1,
          colCode: "orderNo",
        },
        {
          colName: intl.formatMessage({
            id: "trackingShipmentOrderType",
            defaultMessage: "Type",
          }),
          sequence: 2,
          colCode: "orderType",
        },
        // {
        //   colName: intl.formatMessage({
        //     id: "trackingShipmentTaskNo",
        //     defaultMessage: "Task No.",
        //   }),
        //   sequence: 3,
        //   colCode: "taskNo",
        // },
        {
          colName: intl.formatMessage({
            id: "trackingShipmentCustomer",
            defaultMessage: "Customer",
          }),
          sequence: 3,
          colCode: "contact.customerContactName",
        },
        // {
        //   colName: intl.formatMessage({
        //     id: "trackingShipmentRecipient",
        //     defaultMessage: "Recipient",
        //   }),
        //   sequence: 5,
        //   colCode: "contact.customerContactName",
        // },
        {
          colName: intl.formatMessage({
            id: "deliveryShipmentColumnsPhone",
            defaultMessage: "Phone",
          }),
          sequence: 4,
          colCode: "contact.customerContactPhone",
        },
        {
          colName: intl.formatMessage({
            id: "deliveryShipmentColumnsParcels",
            defaultMessage: "Parcels",
          }),
          sequence: 5,
          colCode: "totalParcel",
        },
        {
          colName: intl.formatMessage({
            id: "trackingShipmentCustomer’sShippingPrice",
            defaultMessage: "Customer’s Shipping Price",
          }),
          sequence: 6,
          colCode: "customerShippingPriceNumber",
        },
        // {
        //   colName: intl.formatMessage({
        //     id: "trackingShipmentPayment",
        //     defaultMessage: "Payment",
        //   }),
        //   sequence: 9,
        //   colCode: "paymentStatusText",
        // },
        {
          colName: intl.formatMessage({
            id: "trackingShipmentStatus",
            defaultMessage: "Status",
          }),
          sequence: 7,
          colCode: "statusText",
        },
        {
          colName: intl.formatMessage({
            id: "trackingShipmentPlanShippingDate",
            defaultMessage: "Plan Shipping Date",
          }),
          sequence: 8,
          colCode: "planShippingDate2",
        },
        {
          colName: intl.formatMessage({
            id: "trackingShipmentPlanShippingTime",
            defaultMessage: "Plan Shipping Time",
          }),
          sequence: 9,
          colCode: "planShippingTime",
        },
        // {
        //   colName: intl.formatMessage({
        //     id: "deliveryShipmentColumnsAssignee",
        //     defaultMessage: "Assignee",
        //   }),
        //   sequence: 13,
        //   colCode: "assignee",
        //   width: 150,
        // },
        {
          colName: intl.formatMessage({
            id: "trackingShipmentActualCompletedDate",
            defaultMessage: "Actual Completed Date",
          }),
          sequence: 10,
          colCode: "actualShippingDate",
        },
        {
          colName: intl.formatMessage({
            id: "trackingShipmentActualCompletedTime",
            defaultMessage: "Actual Completed Time",
          }),
          sequence: 11,
          colCode: "actualShippingTime",
        },
        // {
        //   colName: intl.formatMessage({
        //     id: "trackingShipmentSource",
        //     defaultMessage: "Source",
        //   }),
        //   sequence: 16,
        //   colCode: "source.address_name",
        // },
        // {
        //   colName: intl.formatMessage({
        //     id: "trackingShipmentSourceAddress",
        //     defaultMessage: "Source Address",
        //   }),
        //   sequence: 17,
        //   colCode: "source.address",
        // },
        {
          colName: intl.formatMessage({
            id: "trackingShipmentDestinationName",
            defaultMessage: "Destination",
          }),
          sequence: 12,
          colCode: "destination.address_name",
        },
        {
          colName: intl.formatMessage({
            id: "trackingShipmentDestinationAddress",
            defaultMessage: "Destination Address",
          }),
          sequence: 13,
          colCode: "destination.address",
        },
        {
          colName: intl.formatMessage({
            id: "trackingShipmentReference",
            defaultMessage: "Reference No.",
          }),
          sequence: 14,
          colCode: "referenceNo",
        },
        {
          colName: intl.formatMessage({
            id: "trackingShipmentRemark",
            defaultMessage: "Remark",
          }),
          sequence: 15,
          colCode: "remark",
        },
        {
          colName: intl.formatMessage({
            id: "trackingShipmentCreateDate",
            defaultMessage: "Create Date",
          }),
          sequence: 16,
          colCode: "createdAtDate",
        },
        {
          colName: intl.formatMessage({
            id: "trackingShipmentCreateTime",
            defaultMessage: "Create Time",
          }),
          sequence: 17,
          colCode: "createdAtTime",
        },
      ],
    };

    try {
      const response = await instance.post(
        `/v5/order/manager/company/${comCode}/web/deliveryorder/report/loopmerchant/export`,
        body
      );

      if (response.status === 200) {
        window.open(_.get(response, "data.data.data.url"));
        successNotification(response.data.status.message);
      } else {
        errorNotification(response.data.status.message);
      }
    } catch (error) {
      return error.response.data;
    }
  };

  return (
    <div className="d-flex flex-column w-100 h-100 p-3 justify-content-between">
      <div style={{ marginBottom: "10px" }}>
        <Row gutter={isMobile ? [16, 24] : [16, 16]}>
          <Col span={24}>
            <SearchCardWithFilter
              handleSerchShipment={handleSerchShipment}
              onToggleFilter={onToggleFilter}
              filterDot={filterDot}
            />
            <div style={{ display: filterVisible ? undefined : "none" }}>
              <FilterTracking
                handleFilterShipment={handleFilterShipment}
                shipmentStatus={shipmentStatus}
                handleApply={handleApply}
                handleReset={handleReset}
                shipmentFilter={shipmentFilter}
              />
            </div>
          </Col>

          <Col span={24}>
            {/* test */}
            {/* <ShipmentList
              shipmentData={shipmentData}
              total={total}
              handleChangePage={handleChangePage}
              setEvent={setEvent}
              exportOrdersList={exportOrdersList}
              isDesktop={isDesktop}
            /> */}
          </Col>
        </Row>
      </div>
      {/* <Typography
        isBold
        className={`text-center w-100 ${isDesktop ? "pb-3" : "pb-1"}`}
        size={isDesktop ? "18px" : "14px"}
        color={COLORS.Gray}
      >
        <FormattedMessage
          id="textCustomerService"
          defaultMessage="Customer Service : 02-111-0099"
        />
      </Typography> */}
      {!isDesktop && (
        <div
          className={`d-flex align-items-center ${
            isDesktop ? "justify-content-start" : "justify-content-center"
          } px-4`}
          style={{
            height: 46,
            backgroundColor: COLORS.Primary,
            padding: "24px",
            width: "100vw",
            marginLeft: "-16px",
            // marginTop: "16px",
            marginBottom: "-16px",
          }}
        >
          <Typography size="12.5px" color={COLORS.White}>
            Powered by © RAPIDTECH Co., Ltd. (V 1.0)
          </Typography>
        </div>
      )}
    </div>
  );
};

export default Tracking;
